<template>
  <div class="business_hall">
    <common-header myProject />
    <div class="main">
      <div class="width-1260">
        <el-breadcrumb>
          <el-breadcrumb-item :to="{ path: '/' }">联采首页</el-breadcrumb-item>
          <el-breadcrumb-item>联采项目大厅</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="select_warp width-1260">
        <div class="city_sel sel_box flex flex_row align_start">
          <div class="sel_name">所在城市：</div>
          <el-radio-group
            class="label_span flex flex_row align_center"
            v-model="cityRadio"
            @change="changeCity"
          >
            <el-radio-button :border="false" label="null">不限</el-radio-button>
            <el-radio-button
              :border="false"
              v-for="(e, i) in cityLst"
              :key="i"
              :label="e.cityCode"
              >{{ e.cityName }}</el-radio-button
            >
          </el-radio-group>
        </div>
        <div class="cate_sel sel_box flex flex_row align_start mt-14">
          <div class="sel_name">材料品类：</div>
          <el-radio-group
            class="label_span flex flex_row align_center"
            v-model="cateRadio"
            @change="changeCate"
          >
            <el-radio-button :border="false" label="null">不限</el-radio-button>
            <el-radio-button
              :border="false"
              v-for="(e, i) in cateLst"
              :key="i"
              :label="e.categoryId"
              >{{ e.categoryName }}</el-radio-button
            >
          </el-radio-group>
        </div>
      </div>
      <div class="main_list width-1260">
        <div class="filter_tit flex justify_between">
          <el-radio-group v-model="radioStatus" @change="changeStatus">
            <el-radio
              v-for="(e, i) in statusOptionLst"
              :key="i"
              :label="e.value"
              >{{ e.name }}</el-radio
            >
          </el-radio-group>
          <el-radio-group v-model="radioTime" @change="changeTime">
            <el-radio
              v-for="(e, i) in timeOptionLst"
              :key="i"
              :label="e.value"
              >{{ e.name }}</el-radio
            >
          </el-radio-group>
        </div>
        <div class="list">
          <ul class="list_wrap">
            <li
              v-for="(ele, ind) in listData"
              :key="ind"
              @click="gobusiDetail(ele.id)"
            >
              <div class="align_center mt-14">
                <div
                  class="font-16 font-w-600 d-inline-b margin-r-10 line-h-24"
                >
                  {{ ele.planName }}
                </div>
                <el-tag v-if="ele.currentProcess && ele.currentProcess === 1"
                  >联采招募</el-tag
                >
                <el-tag
                  v-if="ele.currentProcess && ele.currentProcess === 2"
                  type="warning"
                  >开始采购</el-tag
                >
                <el-tag
                  v-if="ele.currentProcess && ele.currentProcess === 3"
                  type="success"
                  >正在履约</el-tag
                >
              </div>
              <div class="flex flex_row justify_between mt-14">
                <p class="item_left">
                  <span
                    class="mr-40"
                    v-if="ele.currentProcess && ele.currentProcess !== 1"
                    >计划采购额：{{ ele.purchaseAmount }}</span
                  >
                  <span
                    >有效期：{{ ele.validityStartDate }}至{{
                      ele.validityEndDate
                    }}</span
                  >
                </p>
                <span class="item_right"
                  >参与联采企业数：{{ ele.purchaserCount }}</span
                >
              </div>
              <div class="flex flex_row justify_between mt-14">
                <span class="item_left"
                  >项目所在地：{{ ele.projectLocation }}</span
                >
                <span class="item_right"
                  >联采项目数：{{ ele.projectCount }}</span
                >
              </div>
              <div class="flex flex_row justify_between mt-14 mb-10">
                <div class="item_left">
                  <span>联采品类：</span>
                  <el-tag
                    style="margin-right: 10px"
                    type="info"
                    v-for="(item, j) in ele.categoryNameList"
                    :key="j"
                    >{{ item }}</el-tag
                  >
                </div>
                <span class="item_right"
                  >已报名比价企业数：{{ ele.supplierCount }}</span
                >
              </div>
            </li>
          </ul>
          <div class="pagination page-gray">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNumber"
              :page-size="pageSize"
              :page-sizes="[12, 24, 36, 48, 60]"
              :background="false"
              layout="total, prev, pager, next, sizes, jumper"
              :total="listTotal"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <common-footer />
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import { commonApi } from "@/api/commonApi";
import CommonFooter from "@/components/commonFooter/index.vue";
import CommonHeader from "@/components/commonHeader/index.vue";
import { useRouter } from "vue-router";
import { ElMessage, ElLoading } from "element-plus";
import { SUCCEED_CODE, DetailStatus } from "../../constants";
export default {
  components: {
    CommonFooter,
    CommonHeader,
  },
  name: "businessHall",
  setup() {
    const router = useRouter(); //
    const cityLst = ref([]);
    const cateLst = ref([]);
    const listData = ref([]);
    const pageNumber = ref(1);
    const pageSize = ref(10);
    const listTotal = ref(0);
    const cityRadio = ref("null");
    const cateRadio = ref("null");
    const radioStatus = ref(0);
    const radioTime = ref("null");
    const timeOptionLst = ref([
      { name: "全部", value: "null" },
      { name: "近七天", value: "day" },
      { name: "近一月", value: "month" },
      { name: "近一年", value: "year" },
    ]);
    const statusOptionLst = ref([
      { name: "全部", value: 0 },
      { name: "联采招募", value: 1 },
      { name: "开始采购", value: 2 },
      { name: "正在履约", value: 3 },
    ]);

    onMounted(() => {
      getCityList();
      getCategoryList();
      // cityRadio.value = router.currentRoute.value.query.cityCode || "null";
      cateRadio.value = router.currentRoute.value.query.categoryId || "null";
      getPlanList();
    });

    const getCityList = () => {
      const listLoading = ElLoading.service({
        target: ".main",
        fullscreen: true,
      });
      commonApi.getCityList().then((res) => {
        listLoading.close();
        const { data, message, statusCode } = res;
        if (statusCode === SUCCEED_CODE) {
          cityLst.value = data;
        } else {
          ElMessage.error(message || "获取列表失败！");
        }
      });
    };
    const getCategoryList = () => {
      const listLoading = ElLoading.service({
        target: ".main",
        fullscreen: true,
      });
      commonApi.getCategoryList().then((res) => {
        listLoading.close();
        const { data, message, statusCode } = res;
        if (statusCode === SUCCEED_CODE) {
          cateLst.value = data;
        } else {
          ElMessage.error(message || "获取列表失败！");
        }
      });
    };
    const getPlanList = () => {
      const listLoading = ElLoading.service({
        target: ".main",
        fullscreen: true,
      });
      const params = {
        currentPage: pageNumber.value,
        pageSize: pageSize.value,
        categoryId: cateRadio.value === "null" ? null : cateRadio.value,
        cityCode: cityRadio.value === "null" ? null : cityRadio.value,
        currentProcess: radioStatus.value === 0 ? null : radioStatus.value,
        dateType: radioTime.value === "null" ? null : radioTime.value,
      };
      commonApi.getPlanList(params).then((res) => {
        listLoading.close();
        const { total, data, message, statusCode } = res;
        if (statusCode === SUCCEED_CODE) {
          listData.value = data;
          listTotal.value = total;
        } else {
          ElMessage.error(message || "获取列表失败！");
        }
      });
    };
    //当前流程
    const changeStatus = (val) => {
      radioStatus.value = val;
      getPlanList();
    };
    // 时间范围查询
    const changeTime = (val) => {
      radioTime.value = val;
      getPlanList();
    };
    // 城市
    const changeCity = (val) => {
      cityRadio.value = val;
      getPlanList();
    };
    // 类别
    const changeCate = (val) => {
      cateRadio.value = val;
      getPlanList();
    };
    const handleCurrentChange = (val) => {
      pageNumber.value = val;
      getPlanList();
    };

    const handleSizeChange = (val) => {
      pageSize.value = val;
      getPlanList();
    };

    //去详情
    const gobusiDetail = (id) => {
      router.push({ path: "/businessHall/businessDetail", query: { id: id } });
      // window.open(
      //   router.resolve({
      //     path: "/businessHall/businessDetail",
      //     query: { id: id },
      //   }).href);
    };

    return {
      listData,
      DetailStatus,
      pageNumber,
      pageSize,
      listTotal,
      cityLst,
      cateLst,
      cityRadio,
      cateRadio,
      radioStatus,
      radioTime,
      timeOptionLst,
      statusOptionLst,
      gobusiDetail,
      handleCurrentChange,
      handleSizeChange,
      changeStatus,
      changeTime,
      changeCity,
      changeCate,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
